import { render } from "./DefinitionCard.vue?vue&type=template&id=38b1bf60&scoped=true"
import script from "./DefinitionCard.vue?vue&type=script&lang=js"
export * from "./DefinitionCard.vue?vue&type=script&lang=js"

import "./DefinitionCard.vue?vue&type=style&index=0&id=38b1bf60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b1bf60"]])

export default __exports__